import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { accountSelector } from '../store/shared/accountSlice';

const userAdminNavigate = () => {
  const { currentAccountId } = useSelector(accountSelector);
  const navigate = useNavigate();
  const redirect = (path: string, options: {} = {}) => {
    navigate(`/admin/${currentAccountId}/${path}`, options);
  };
  return { navigate: redirect };
};
export default userAdminNavigate;
